import { render, staticRenderFns } from "./change-name-modal.vue?vue&type=template&id=744223bd&"
import script from "./change-name-modal.vue?vue&type=script&lang=js&"
export * from "./change-name-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports